@if (tabs.length > 1) {
  <div class="bare-list tabs__list">
    @for (tab of tabs; track tab) {
      <h6 class="tabs__item"
        [attr.data-test]="'tab-' + tab"
        [ngClass]="{'is-active is-active__bar': currentTab === tab}"
        (click)="changeTab(tab)">
        {{ 'spare-part-order-history.' + tab + '-tab-title' | translate }}
      </h6>
    }
  </div>
}
@if (currentTab === ESparePartsOrderHistoryTabs.ORDERS) {
  <div class="orders"
    [attr.data-test]="'div-orders'">
    <app-spare-part-order-history
      [orders]="orders"
      [allLoadedOrders]="allLoadedOrders"
      [ordersLoading]="ordersLoading">
    </app-spare-part-order-history>
    <app-pagination-linkless
      [pageCount]="ordersNumPages"
      [currentPage]="ordersCurrentPage"
      (pageChange)="goToOrdersPage($event)">
    </app-pagination-linkless>
  </div>
}
@if (currentTab === ESparePartsOrderHistoryTabs.ARCHIVE) {
  <div class="archive"
    [attr.data-test]="'div-archive'">
    <app-spare-part-hybris-order-history
      [hybrisOrders]="hybrisOrders"
      [hybrisOrdersLoading]="hybrisOrdersLoading">
    </app-spare-part-hybris-order-history>
  </div>
}
